var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 8.9375C4.5 6.76288 6.26288 5 8.4375 5C10.6121 5 12.375 6.76288 12.375 8.9375C12.375 11.1121 10.6121 12.875 8.4375 12.875C6.26288 12.875 4.5 11.1121 4.5 8.9375ZM10.6875 8.9375C10.6875 7.69486 9.68014 6.6875 8.4375 6.6875C7.19486 6.6875 6.1875 7.69486 6.1875 8.9375C6.1875 10.1801 7.19486 11.1875 8.4375 11.1875C9.68014 11.1875 10.6875 10.1801 10.6875 8.9375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 8.9375C15.75 6.76288 17.5129 5 19.6875 5C21.8621 5 23.625 6.76288 23.625 8.9375C23.625 11.1121 21.8621 12.875 19.6875 12.875C17.5129 12.875 15.75 11.1121 15.75 8.9375ZM21.9375 8.9375C21.9375 7.69486 20.9301 6.6875 19.6875 6.6875C18.4449 6.6875 17.4375 7.69486 17.4375 8.9375C17.4375 10.1801 18.4449 11.1875 19.6875 11.1875C20.9301 11.1875 21.9375 10.1801 21.9375 8.9375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 20.1875C4.5 18.0129 6.26288 16.25 8.4375 16.25C10.6121 16.25 12.375 18.0129 12.375 20.1875C12.375 22.3621 10.6121 24.125 8.4375 24.125C6.26288 24.125 4.5 22.3621 4.5 20.1875ZM10.6875 20.1875C10.6875 18.9449 9.68014 17.9375 8.4375 17.9375C7.19486 17.9375 6.1875 18.9449 6.1875 20.1875C6.1875 21.4301 7.19486 22.4375 8.4375 22.4375C9.68014 22.4375 10.6875 21.4301 10.6875 20.1875Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 20.1875C15.75 18.0129 17.5129 16.25 19.6875 16.25C21.8621 16.25 23.625 18.0129 23.625 20.1875C23.625 22.3621 21.8621 24.125 19.6875 24.125C17.5129 24.125 15.75 22.3621 15.75 20.1875ZM21.9375 20.1875C21.9375 18.9449 20.9301 17.9375 19.6875 17.9375C18.4449 17.9375 17.4375 18.9449 17.4375 20.1875C17.4375 21.4301 18.4449 22.4375 19.6875 22.4375C20.9301 22.4375 21.9375 21.4301 21.9375 20.1875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryCheck);
export default __webpack_public_path__ + "static/media/categoryCheck.c4ca2b21e350ef2b7cd63124ffaae70f.svg";
export { ForwardRef as ReactComponent };